import Description from "@/components/common/Description";

interface Props {
	dueEntries: number;
	nextEntryLabel: string;
}

const EntryDue = ({ dueEntries, nextEntryLabel }: Props) => {
	// Only show if there are multiple entries due
	if (dueEntries <= 1) {
		return (
			<Description>
				Your entry for {nextEntryLabel?.toLowerCase()} is due.
			</Description>
		);
	}

	return <Description>{dueEntries} entries due for this form.</Description>;
};

export default EntryDue;
